import React from 'react';
import InputText from 'components/Inputs/inputText';
import PropTypes from 'prop-types';
import { Button, Card } from 'xland-ui';
import { useChat } from './hooks/useChat';
import Message from './Message';
import './styles.scss';

function Chat({ context }) {
  const {
    messages,
    input,
    setInput,
    isLoading,
    handleSendMessage,
    messagesEndRef,
  } = useChat({ context });

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const welcomeMessage = {
    role: 'assistant',
    content: 'Bienvenido, ¿cómo puedo ayudarte?',
  };

  return (
    <Card className='chat-container mb-5'>
      <div
        className='messages-area'
        style={{ height: '300px', overflowY: 'auto' }}
      >
        {messages.length > 0
          ? messages.map((msg, index) => (
            <Message key={`message-${index}`} {...msg} />
          ))
          : <Message {...welcomeMessage} />}
        <div ref={messagesEndRef} />
      </div>

      <div className='input-area'>
        <div className='input-wrapper'>
          <InputText
            className='mb-0'
            value={input}
            onChange={setInput}
            onKeyPress={handleKeyPress}
            placeholder='Escribe tu mensaje...'
            disabled={isLoading}
            aria-label='Mensaje'
          />
          <Button
            type='submit'
            onClick={handleSendMessage}
            text='Enviar'
            disabled={isLoading || !input.trim()}
            aria-label='Enviar mensaje'
          />
        </div>
      </div>
    </Card>
  );
}

Chat.propTypes = {
  context: PropTypes.object.isRequired,
};

export default Chat;
